<template>
  <div class="row custom-record">
    <div class="col-md-1">
      <input v-model="isChecked" type="checkbox" class="custom-checkbox" />
    </div>
    <div class="col-md-2 custom-data">
      <span>{{ recordData.addressTypeName }}</span>
    </div>
    <div class="col-md-5 custom-data">
      <span>{{ recordData.addressLines }}</span>
      <span>{{ recordData.city }}, {{ recordData.stateProvinceName }} {{ recordData.postalCode }}</span>
    </div>
    <div class="col-md-2">
      <span v-show="recordData.isPrimary">(primary)</span>
    </div>
    <div class="col-md-1">
      <a href="#" @click="editItem">edit</a>
    </div>
    <div class="col-md-1"></div>
  </div>
</template>
<script>
export default {
  name: 'ContactAddressRecord',
  props: {
    recordData: Object
  },
  emits: ['itemChecked', 'editItem'],
  computed: {
    isChecked: {
      get() {
        let _is = false
        if (this.recordData) {
          if (this.recordData.isChecked) {
            _is = true
          }
        }
        return _is
      },
      set(value) {
        this.$emit(
          'itemChecked',
          {
            contactAddress: this.recordData.contactAddress,
            contact: this.recordData.contact,
            address: this.recordData.address
          },
          value
        )
      }
    }
  },
  methods: {
    editItem() {
      this.$emit('editItem', this.recordData)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-record {
  padding: 5px;
}
.custom-data {
  text-align: left;
}
</style>
